import React from 'react';
import { Link } from 'react-router-dom';

interface CategoryCardProps {
  title: string;
  imageSrc: string;
  url: string;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ title, imageSrc, url }) => {
  return (
    <Link to={url} className="group">
      <div className="lux-card overflow-hidden">
        <div className="relative h-56 mb-4 overflow-hidden rounded">
          <img 
            src={imageSrc} 
            alt={title} 
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-luxdark/50 to-transparent transition-opacity duration-300"></div>
        </div>
        <h3 className="text-xl font-medium text-center">{title}</h3>
        <div className="mt-2 flex justify-center">
          <span className="inline-block w-10 h-0.5 bg-luxgold transition-all duration-300 group-hover:w-20"></span>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;